import { MailInfo } from './../model/mail-info.model';
import { Pipe, PipeTransform } from '@angular/core';
import { StringService } from '../service/string.service';

@Pipe({
  name: 'setTitleString'
})
export class SetTitleStringPipe
  implements PipeTransform {

  constructor( private stringService: StringService ) {}

  transform(mail: MailInfo, baseKeywords: string[]): any {
    const titleJson = JSON.parse(mail.title_json || '{}');

    if (Object.keys(titleJson).length) {
      for (const wordKey in titleJson) {
        // json構造 {行番号: {単語番号: [表示する単語名, 意味語, 重要度], ..}}
        let vocabularyWord = this.stringService.checkKeywordDecoration(
          mail.matched_skills,
          baseKeywords,
          titleJson[wordKey][0],
          titleJson[wordKey][1],
          titleJson[wordKey][2]
        )
        titleJson[wordKey][0] = vocabularyWord
      }
      // エスケープ処理済みの title_jsonの第一要素「表示する単語名」を取得
      const titleParts = Object.values(titleJson).map(this.stringService.escapeHTMLTags);
      // 取得した文字列要素を結合したものをtitleとして返却
      const title = titleParts.join('');
      return title;
    } else {
      return mail.title;
    }
  }
}
